import { render, staticRenderFns } from "./import-average-expenses.vue?vue&type=template&id=48650665&scoped=true&"
import script from "./import-average-expenses.vue?vue&type=script&lang=js&"
export * from "./import-average-expenses.vue?vue&type=script&lang=js&"
import style0 from "./import-average-expenses.vue?vue&type=style&index=0&id=48650665&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48650665",
  null
  
)

export default component.exports